var map = {
	"./about-bg.png": 14237,
	"./about-us-eight.png": 65186,
	"./app-img.png": 72045,
	"./app-sec-five.png": 52114,
	"./apple-five.png": 89241,
	"./application.svg": 21664,
	"./appstore-five.png": 30939,
	"./appstore-five.svg": 97519,
	"./appstore.png": 60236,
	"./appstore.svg": 24934,
	"./audi.png": 75207,
	"./avatar-big.jpg": 29574,
	"./banner-02.jpg": 90715,
	"./banner-03.jpg": 54206,
	"./banner-five-bg.jpg": 61653,
	"./banner-home-2.png": 99605,
	"./banner-img-01.jpg": 45902,
	"./banner-img-02.jpg": 36665,
	"./banner-img-03.jpg": 31964,
	"./banner-img-04.jpg": 37959,
	"./banner.jpg": 76658,
	"./banner.png": 80758,
	"./bg-wave.png": 28339,
	"./bg/authentication-bg.png": 91608,
	"./bg/banner-bg.png": 30954,
	"./bg/bg-01.svg": 37341,
	"./bg/bg-02.svg": 25246,
	"./bg/bg-03.svg": 87823,
	"./bg/bg-04.svg": 70352,
	"./bg/bg-05.svg": 85153,
	"./bg/bg-06.svg": 3410,
	"./bg/bg-07.png": 11901,
	"./bg/bg-08.png": 35306,
	"./bg/bg-09.png": 86067,
	"./bg/bg-10.png": 1581,
	"./bg/bg-11.png": 38340,
	"./bg/bg-12.png": 23615,
	"./bg/bg-13.png": 69814,
	"./bg/bg-banner.png": 70348,
	"./bg/bg-graphics.png": 48697,
	"./bg/bg-wave.png": 69221,
	"./bg/book-bg-01.svg": 27889,
	"./bg/book-bg-02.svg": 47490,
	"./bg/breadcrumb-bg-01.png": 33141,
	"./bg/breadcrumb-bg-02.png": 47390,
	"./bg/business-bg.png": 56698,
	"./bg/buttom-wave.png": 3739,
	"./bg/buttom-waves.png": 91736,
	"./bg/categories-bg.png": 23528,
	"./bg/category-bg.svg": 28326,
	"./bg/circle-lg.png": 76582,
	"./bg/client-bg1.svg": 44226,
	"./bg/corner-dot.png": 7355,
	"./bg/corner-large.png": 2991,
	"./bg/corner-small.png": 76167,
	"./bg/cutter.png": 93855,
	"./bg/dot-blue.png": 18920,
	"./bg/dot-white-2.png": 87380,
	"./bg/dot-white.png": 5981,
	"./bg/dotted.png": 87438,
	"./bg/ellipse-01.png": 60072,
	"./bg/ellipse-02.png": 45347,
	"./bg/error-404.png": 24265,
	"./bg/error-500.png": 26188,
	"./bg/foot-top-bg.svg": 84256,
	"./bg/home-banner-bg-01.png": 86104,
	"./bg/home-banner-bg-02.png": 81715,
	"./bg/home-banner-bg-03.png": 49802,
	"./bg/index-6-bg.png": 36621,
	"./bg/index-6-left-circle.png": 84994,
	"./bg/index-6-oval-img.png": 6410,
	"./bg/index-6-right-img.png": 10458,
	"./bg/index-6-top-circle.png": 16094,
	"./bg/index-g-overlay-gradient.png": 40990,
	"./bg/journey-bg.jpg": 82142,
	"./bg/launch.png": 22975,
	"./bg/maintenance.png": 94829,
	"./bg/offer-bg.png": 95328,
	"./bg/open-work-1.png": 76400,
	"./bg/our-company-bg.png": 20878,
	"./bg/our-company-six.png": 96863,
	"./bg/pet-bg-01.png": 23647,
	"./bg/pet-bg-02.png": 10084,
	"./bg/phone.png": 87304,
	"./bg/price-bg-vector-2.png": 37310,
	"./bg/price-bg-vector.png": 89075,
	"./bg/provide-bg-01.svg": 61769,
	"./bg/provide-bg-02.svg": 16954,
	"./bg/session-expired.png": 46824,
	"./bg/spring-01.png": 19485,
	"./bg/square-sm.png": 158,
	"./bg/stipes.png": 72712,
	"./bg/testimonial-bg-01.png": 54917,
	"./bg/testimonial-bg-02.png": 83118,
	"./bg/testimonial-bg-03.png": 26135,
	"./bg/testimonial-bg-03.svg": 26917,
	"./bg/title-bg-01.png": 70658,
	"./bg/title-bg.png": 1668,
	"./bg/transperent-circle copy.png": 78202,
	"./bg/transperent-circle.png": 26341,
	"./bg/wave.png": 74205,
	"./bg/work-bg-01.png": 58957,
	"./bg/work-bg-01.svg": 58497,
	"./bg/work-bg-02.png": 68278,
	"./bg/work-bg-02.svg": 53458,
	"./bg/work-bg-03.png": 46367,
	"./bg/wrk-bg-01.png": 44202,
	"./bg/wrk-bg-02.png": 93185,
	"./bg/wrk-bg-03.png": 8568,
	"./bg/wrk-bg-04.png": 87,
	"./blog-details.jpg": 85493,
	"./blog/blog-01.jpg": 63373,
	"./blog/blog-02.jpg": 94146,
	"./blog/blog-03.jpg": 85855,
	"./blog/blog-04.jpg": 7572,
	"./blog/blog-05.jpg": 79377,
	"./blog/blog-06.jpg": 63526,
	"./blog/blog-07.jpg": 53635,
	"./blog/blog-08.jpg": 96024,
	"./blog/blog-09.jpg": 341,
	"./blog/blog-10.jpg": 82255,
	"./blog/blog-11.jpg": 9874,
	"./blog/blog-12.jpg": 19773,
	"./blog/blog-13.jpg": 68640,
	"./blog/blog-14.jpg": 51475,
	"./blog/blog-15.jpg": 65014,
	"./blog/blog-16.jpg": 35361,
	"./blog/blog-17.jpg": 57316,
	"./blog/celaning-blog-01.jpg": 46253,
	"./blog/celaning-blog-02.jpg": 16994,
	"./blog/celaning-blog-03.jpg": 29663,
	"./blog/house-blog-01.jpg": 6722,
	"./blog/house-blog-02.jpg": 52653,
	"./blog/house-blog-03.jpg": 84080,
	"./blog/mechanic-blog-01.jpg": 87420,
	"./blog/mechanic-blog-02.jpg": 72075,
	"./blog/mechanic-blog-03.jpg": 94030,
	"./blog/mechanic-blog-04.jpg": 29653,
	"./blogs/blog-01.jpg": 53872,
	"./blogs/blog-02.jpg": 21247,
	"./blogs/blog-03.jpg": 29538,
	"./blogs/blog-04.jpg": 14769,
	"./blogs/blog-05.jpg": 42964,
	"./bubbles-bottom-section-pricing-1.png": 82550,
	"./bubbles-bottom-section.png": 83009,
	"./bubbles-offering-section.png": 70786,
	"./business.jpg": 14198,
	"./car-blog-2.png": 73070,
	"./car-blog-ng.jpg": 45287,
	"./car-category-five.png": 46778,
	"./car-five-arrow.png": 25787,
	"./car-provider-bg.png": 86062,
	"./car-wash/car-01.jpg": 349,
	"./car-wash/car-02.jpg": 62546,
	"./car-wash/car-03.jpg": 22575,
	"./car-wash/car-05.jpg": 69793,
	"./car-wash/car-06.jpg": 94006,
	"./car-wash/car-07.jpg": 38771,
	"./car-wash/car-08.jpg": 69032,
	"./car-wash/car-09.jpg": 96645,
	"./car-wash/car-4.jpg": 79094,
	"./categories/categories-01.jpg": 38065,
	"./categories/categories-02.jpg": 96646,
	"./categories/categories-03.jpg": 61347,
	"./categories/categories-04.jpg": 46544,
	"./categories/categories-05.jpg": 89997,
	"./categories/categories-06.jpg": 41506,
	"./categories/categories-07.jpg": 61503,
	"./categories/categories-08.jpg": 33756,
	"./categories/categories-09.jpg": 31129,
	"./categories/categories-10.jpg": 67635,
	"./categories/categories-11.jpg": 12374,
	"./categories/categories-12.jpg": 45633,
	"./catering-01.jpg": 29163,
	"./catering/Frame 12.svg": 73104,
	"./catering/catering-05.jpg": 96219,
	"./catering/catering-06.jpg": 35596,
	"./catering/catering-07.jpg": 90857,
	"./catering/catering-08.jpg": 20050,
	"./catering/catering-09.jpg": 80079,
	"./catering/catering-10.jpg": 23761,
	"./catering/catering-11.jpg": 9428,
	"./catering/catering-12.jpg": 55491,
	"./catering/catering-13.jpg": 96006,
	"./catering/catering-banner.jpg": 69012,
	"./catering/catering-service-01.png": 83901,
	"./catering/catering-service-02.png": 42662,
	"./catering/catering-service-03.png": 81679,
	"./catering/catering-service-04.png": 38832,
	"./catering/catering-service-05.png": 35737,
	"./catering/catering-service-06.png": 87554,
	"./catering/catering-service-07.png": 8683,
	"./catering/catering-service-08.png": 5084,
	"./catering/catering-service-09.png": 34501,
	"./catering/catering-service-10.png": 61439,
	"./catering/catring-01.jpg": 15654,
	"./catering/catring-02.jpg": 43409,
	"./catering/catring-03.jpg": 29076,
	"./catering/catring-04.jpg": 80511,
	"./catering/logo-01.svg": 11259,
	"./catering/logo-02.svg": 95720,
	"./catering/logo-03.svg": 8089,
	"./catering/logo-04.svg": 51254,
	"./catering/logo-05.svg": 98119,
	"./catering/logo-06.svg": 49908,
	"./client/client-01.jpg": 23651,
	"./client/client-02.jpg": 29172,
	"./customer-review-after.png": 38182,
	"./customer-review-before.png": 76864,
	"./favicon.png": 67905,
	"./favicon.svg": 45278,
	"./feature.jpg": 99472,
	"./flags/ad.png": 94663,
	"./flags/ae.png": 76350,
	"./flags/af.png": 43701,
	"./flags/ag.png": 74604,
	"./flags/ai.png": 14546,
	"./flags/al.png": 1759,
	"./flags/am.png": 5430,
	"./flags/ao.png": 47108,
	"./flags/ar.png": 91553,
	"./flags/as.png": 6936,
	"./flags/at.png": 98455,
	"./flags/au.png": 39086,
	"./flags/aw.png": 97820,
	"./flags/ax.png": 1419,
	"./flags/az.png": 28473,
	"./flags/ba.png": 17819,
	"./flags/bb.png": 20256,
	"./flags/bd.png": 94486,
	"./flags/be.png": 48287,
	"./flags/bf.png": 63012,
	"./flags/bg.png": 26253,
	"./flags/bh.png": 57018,
	"./flags/bi.png": 63203,
	"./flags/bj.png": 84872,
	"./flags/bl.png": 88702,
	"./flags/bm.png": 64487,
	"./flags/bn.png": 13804,
	"./flags/bo.png": 25429,
	"./flags/bq.png": 43499,
	"./flags/br.png": 78096,
	"./flags/bs.png": 10201,
	"./flags/bt.png": 5222,
	"./flags/bv.png": 67860,
	"./flags/bw.png": 11370,
	"./flags/by.png": 63155,
	"./flags/bz.png": 88664,
	"./flags/ca.png": 20276,
	"./flags/cc.png": 57638,
	"./flags/cd.png": 62617,
	"./flags/cf.png": 12267,
	"./flags/cg.png": 48610,
	"./flags/ch.png": 49477,
	"./flags/ci.png": 15612,
	"./flags/ck.png": 30702,
	"./flags/cl.png": 13793,
	"./flags/cm.png": 41080,
	"./flags/cn.png": 15571,
	"./flags/co.png": 64810,
	"./flags/cr.png": 703,
	"./flags/cu.png": 72672,
	"./flags/cv.png": 70235,
	"./flags/cw.png": 48690,
	"./flags/cx.png": 77845,
	"./flags/cy.png": 66220,
	"./flags/cz.png": 16903,
	"./flags/de.png": 5593,
	"./flags/dj.png": 32558,
	"./flags/dk.png": 32055,
	"./flags/dm.png": 31041,
	"./flags/do.png": 5523,
	"./flags/dz.png": 58366,
	"./flags/ec.png": 72676,
	"./flags/ee.png": 5938,
	"./flags/eg.png": 29920,
	"./flags/er.png": 98653,
	"./flags/es.png": 77524,
	"./flags/et.png": 53163,
	"./flags/fi.png": 26831,
	"./flags/fj.png": 7924,
	"./flags/fk.png": 29053,
	"./flags/fm.png": 53835,
	"./flags/fo.png": 80889,
	"./flags/fr.png": 27020,
	"./flags/ga.png": 73696,
	"./flags/gb.png": 35675,
	"./flags/gd.png": 25709,
	"./flags/ge.png": 71812,
	"./flags/gf.png": 8671,
	"./flags/gg.png": 11734,
	"./flags/gh.png": 89041,
	"./flags/gi.png": 78824,
	"./flags/gl.png": 91701,
	"./flags/gm.png": 55788,
	"./flags/gn.png": 58439,
	"./flags/gp.png": 53177,
	"./flags/gq.png": 46928,
	"./flags/gr.png": 77099,
	"./flags/gs.png": 86594,
	"./flags/gt.png": 48317,
	"./flags/gu.png": 10836,
	"./flags/gw.png": 50758,
	"./flags/gy.png": 57496,
	"./flags/hk.png": 5907,
	"./flags/hn.png": 21038,
	"./flags/hr.png": 39026,
	"./flags/ht.png": 83383,
	"./flags/hu.png": 69005,
	"./flags/id.png": 45535,
	"./flags/ie.png": 67446,
	"./flags/il.png": 30503,
	"./flags/im.png": 42814,
	"./flags/in.png": 28565,
	"./flags/io.png": 62028,
	"./flags/iq.png": 99778,
	"./flags/ir.png": 55865,
	"./flags/is.png": 49616,
	"./flags/it.png": 61839,
	"./flags/je.png": 12727,
	"./flags/jm.png": 65391,
	"./flags/jo.png": 81405,
	"./flags/jp.png": 1018,
	"./flags/ke.png": 75208,
	"./flags/kg.png": 47354,
	"./flags/kh.png": 16589,
	"./flags/ki.png": 53348,
	"./flags/km.png": 10592,
	"./flags/kn.png": 8155,
	"./flags/kp.png": 87397,
	"./flags/kr.png": 58615,
	"./flags/kw.png": 2730,
	"./flags/ky.png": 58196,
	"./flags/kz.png": 80655,
	"./flags/la.png": 82037,
	"./flags/lb.png": 96286,
	"./flags/lc.png": 48775,
	"./flags/li.png": 16045,
	"./flags/lk.png": 99007,
	"./flags/lr.png": 70478,
	"./flags/ls.png": 53623,
	"./flags/lt.png": 47832,
	"./flags/lu.png": 68961,
	"./flags/lv.png": 11530,
	"./flags/ly.png": 38653,
	"./flags/ma.png": 22894,
	"./flags/mc.png": 98460,
	"./flags/md.png": 95859,
	"./flags/me.png": 63946,
	"./flags/mg.png": 248,
	"./flags/mh.png": 75055,
	"./flags/mk.png": 69940,
	"./flags/ml.png": 42232,
	"./flags/mm.png": 29346,
	"./flags/mn.png": 95929,
	"./flags/mo.png": 6032,
	"./flags/mp.png": 1191,
	"./flags/mq.png": 48702,
	"./flags/mr.png": 50805,
	"./flags/ms.png": 98540,
	"./flags/mt.png": 74787,
	"./flags/mu.png": 10682,
	"./flags/mv.png": 31793,
	"./flags/mw.png": 21576,
	"./flags/mx.png": 51423,
	"./flags/my.png": 54486,
	"./flags/mz.png": 68461,
	"./flags/na.png": 36636,
	"./flags/nc.png": 56445,
	"./flags/ne.png": 89675,
	"./flags/nf.png": 2032,
	"./flags/ng.png": 8281,
	"./flags/ni.png": 21943,
	"./flags/nl.png": 79850,
	"./flags/no.png": 10433,
	"./flags/np.png": 19862,
	"./flags/nr.png": 84388,
	"./flags/nu.png": 94331,
	"./flags/nz.png": 14444,
	"./flags/om.png": 98260,
	"./flags/pa.png": 55953,
	"./flags/pe.png": 58613,
	"./flags/pf.png": 72862,
	"./flags/pg.png": 25351,
	"./flags/ph.png": 40608,
	"./flags/pk.png": 2587,
	"./flags/pl.png": 38724,
	"./flags/pm.png": 92621,
	"./flags/pn.png": 78646,
	"./flags/pr.png": 88106,
	"./flags/ps.png": 20019,
	"./flags/pt.png": 22620,
	"./flags/pw.png": 30199,
	"./flags/py.png": 20089,
	"./flags/qa.png": 40522,
	"./flags/re.png": 90831,
	"./flags/ro.png": 23301,
	"./flags/rs.png": 87049,
	"./flags/ru.png": 74527,
	"./flags/rw.png": 3469,
	"./flags/sa.png": 66436,
	"./flags/sb.png": 21087,
	"./flags/sc.png": 24758,
	"./flags/sd.png": 24585,
	"./flags/se.png": 69760,
	"./flags/sg.png": 33874,
	"./flags/sh.png": 63029,
	"./flags/si.png": 93932,
	"./flags/sk.png": 95678,
	"./flags/sl.png": 36689,
	"./flags/sm.png": 38824,
	"./flags/sn.png": 24099,
	"./flags/so.png": 6522,
	"./flags/sr.png": 93743,
	"./flags/ss.png": 54726,
	"./flags/st.png": 47801,
	"./flags/sv.png": 20747,
	"./flags/sx.png": 46565,
	"./flags/sy.png": 17148,
	"./flags/sz.png": 17783,
	"./flags/tc.png": 31775,
	"./flags/td.png": 73120,
	"./flags/tf.png": 79154,
	"./flags/tg.png": 28155,
	"./flags/th.png": 48268,
	"./flags/tj.png": 29054,
	"./flags/tk.png": 16743,
	"./flags/tl.png": 25224,
	"./flags/tm.png": 65169,
	"./flags/tn.png": 56858,
	"./flags/to.png": 78435,
	"./flags/tr.png": 9062,
	"./flags/tt.png": 35856,
	"./flags/tv.png": 86018,
	"./flags/tw.png": 7147,
	"./flags/tz.png": 26542,
	"./flags/ua.png": 61478,
	"./flags/ug.png": 88272,
	"./flags/um.png": 66090,
	"./flags/us-one.png": 97791,
	"./flags/us.png": 70628,
	"./flags/us1.png": 50631,
	"./flags/uy.png": 81470,
	"./flags/uz.png": 67221,
	"./flags/va.png": 41063,
	"./flags/vc.png": 2005,
	"./flags/ve.png": 23427,
	"./flags/vg.png": 9841,
	"./flags/vi.png": 24863,
	"./flags/vn.png": 96832,
	"./flags/vu.png": 39731,
	"./flags/wf.png": 19311,
	"./flags/ws.png": 25266,
	"./flags/ye.png": 97478,
	"./flags/yt.png": 63839,
	"./flags/za.png": 59107,
	"./flags/zm.png": 12447,
	"./flags/zw.png": 61221,
	"./footer-bg.png": 28801,
	"./gallery/gallery-01.jpg": 97727,
	"./gallery/gallery-02.jpg": 83376,
	"./gallery/gallery-03.jpg": 51949,
	"./gallery/gallery-04.jpg": 16518,
	"./gallery/gallery-05.jpg": 76003,
	"./gallery/gallery-06.jpg": 29940,
	"./gallery/gallery-07.jpg": 44273,
	"./gallery/gallery-08.jpg": 73162,
	"./gallery/gallery-09.jpg": 28999,
	"./gallery/gallery-14.jpg": 2997,
	"./gallery/gallery-15.jpg": 58168,
	"./gallery/gallery-16.jpg": 74663,
	"./gallery/gallery-17.jpg": 78858,
	"./gallery/gallery-img-10.jpg": 34435,
	"./gallery/gallery-img-4.jpg": 73530,
	"./gallery/gallery-img-5.jpg": 67991,
	"./gallery/gallery-img-6.jpg": 33768,
	"./gallery/gallery-img-7.jpg": 96133,
	"./gallery/gallery-img-8.jpg": 58742,
	"./gallery/gallery-img-9.jpg": 21907,
	"./gallery/gallery-thumb-01.jpg": 23566,
	"./gallery/gallery-thumb-02.jpg": 30681,
	"./gallery/gallery-thumb-03.jpg": 9628,
	"./gallery/gallery-thumb-04.jpg": 15623,
	"./googleplay-five.png": 74702,
	"./googleplay-five.svg": 32162,
	"./googleplay.png": 19915,
	"./googleplay.svg": 13885,
	"./gplay.png": 42683,
	"./healthy-pets.jpg": 81178,
	"./healthy-pets.png": 45150,
	"./her-section-eight-bg.png": 55639,
	"./hero-section-eight.png": 55588,
	"./hero-section-seven-ryt.png": 22424,
	"./hero-section-seven.png": 91790,
	"./home-01.jpg": 97297,
	"./home-02.jpg": 39526,
	"./home-03.jpg": 78051,
	"./home-04.jpg": 20048,
	"./home-05.jpg": 20973,
	"./home-06.jpg": 8066,
	"./home-07.jpg": 4383,
	"./home-08.jpg": 76636,
	"./home-09.jpg": 20985,
	"./home-10.jpg": 34195,
	"./ico.svg": 39465,
	"./icons/Fries-icon.svg": 40498,
	"./icons/about-book.svg": 63240,
	"./icons/about-documents.svg": 27279,
	"./icons/about-hands.svg": 37779,
	"./icons/app-store.svg": 82560,
	"./icons/apporment-cleaning.svg": 88093,
	"./icons/appstore-six.svg": 71508,
	"./icons/arrow-eight-1.svg": 40142,
	"./icons/arrow-eight-2.svg": 69261,
	"./icons/bank-transfer.svg": 98515,
	"./icons/banner-arrow.svg": 90645,
	"./icons/banner-nine-dot.svg": 28248,
	"./icons/banner-nine-icon-1.svg": 66966,
	"./icons/banner-nine-icon-2.svg": 87253,
	"./icons/book-done.svg": 32965,
	"./icons/branch-icon-01.svg": 86993,
	"./icons/branch-icon-02.svg": 6594,
	"./icons/branch-icon-03.svg": 37171,
	"./icons/branch-icon-04.svg": 80428,
	"./icons/calendar-icon.svg": 48029,
	"./icons/call-calling.svg": 38336,
	"./icons/car-service-icon-1.svg": 68159,
	"./icons/car-service-icon-2.svg": 96460,
	"./icons/car-service-icon-3.svg": 76173,
	"./icons/car-wash-header-1.svg": 76255,
	"./icons/car-wash-header-2.svg": 97228,
	"./icons/car-wash.svg": 90597,
	"./icons/carpet-cleaning.svg": 35661,
	"./icons/carpet.svg": 23834,
	"./icons/category-01.svg": 95601,
	"./icons/category-02.svg": 38498,
	"./icons/category-03.svg": 42227,
	"./icons/category-04.svg": 19660,
	"./icons/category-05.svg": 67021,
	"./icons/category-06.svg": 84046,
	"./icons/category-07.svg": 98687,
	"./icons/category-08.svg": 88472,
	"./icons/category-09.svg": 13833,
	"./icons/category-10.svg": 42755,
	"./icons/category-11.svg": 28114,
	"./icons/category-12.svg": 21249,
	"./icons/category-13.svg": 85712,
	"./icons/category-14.svg": 51599,
	"./icons/category-15.svg": 7870,
	"./icons/category-16.svg": 62045,
	"./icons/category-17.svg": 72572,
	"./icons/catering-01.svg": 116,
	"./icons/catering-02.svg": 71623,
	"./icons/catering-03.svg": 32086,
	"./icons/catering-04.svg": 15769,
	"./icons/catering-05.svg": 50376,
	"./icons/catering-06.svg": 31739,
	"./icons/catering-07.svg": 89770,
	"./icons/catering-08.svg": 58045,
	"./icons/cdn-globe-locations-svgrepo-com.svg": 12058,
	"./icons/charges-1.svg": 95836,
	"./icons/charges-2.svg": 74863,
	"./icons/charges-3.svg": 12286,
	"./icons/choose-icon-01.svg": 56774,
	"./icons/choose-icon-1.svg": 51308,
	"./icons/choose-icon-2.svg": 6655,
	"./icons/choose-icon-3.svg": 1902,
	"./icons/choose-icon-4.svg": 10897,
	"./icons/cleaner-clean-svgrepo-com.svg": 74686,
	"./icons/cleaner-svgrepo-com.svg": 69410,
	"./icons/cleaning-mop.svg": 43233,
	"./icons/commercial-cleaning.svg": 90583,
	"./icons/computer.svg": 56236,
	"./icons/construction.svg": 33552,
	"./icons/consultation-icon-01.svg": 68194,
	"./icons/consultation-icon-02.svg": 22737,
	"./icons/consultation-icon-03.svg": 59936,
	"./icons/consultation-icon-04.svg": 18495,
	"./icons/consultation-icon-05.svg": 97390,
	"./icons/consultation-icon-06.svg": 26509,
	"./icons/coupon-icon.svg": 50265,
	"./icons/covid-cleaning.svg": 12542,
	"./icons/customer-quote.svg": 70724,
	"./icons/cuttor-sm-white.svg": 56565,
	"./icons/cuttor-small.svg": 61842,
	"./icons/cuttor.svg": 79152,
	"./icons/dog-face-eight.svg": 82829,
	"./icons/dog-feet.svg": 44260,
	"./icons/dog.svg": 63935,
	"./icons/dropdown-nine.svg": 22609,
	"./icons/dropdown.svg": 43556,
	"./icons/expereience.svg": 32394,
	"./icons/expert-team.svg": 48555,
	"./icons/fb-icon.svg": 71987,
	"./icons/fb.svg": 19599,
	"./icons/feature-icon-01.svg": 69985,
	"./icons/feature-icon-02.svg": 88242,
	"./icons/feature-icon-03.svg": 21283,
	"./icons/feature-icon-04.svg": 93628,
	"./icons/feature-icon-05.svg": 22173,
	"./icons/feature-icon-06.svg": 10078,
	"./icons/feature-icon-07.svg": 72655,
	"./icons/feature-icon-08.svg": 14504,
	"./icons/feature-icon-09.svg": 79897,
	"./icons/feature-icon-10.svg": 90547,
	"./icons/feature-icon-11.svg": 59970,
	"./icons/feature-icon-12.svg": 40369,
	"./icons/feature-icon-13.svg": 83456,
	"./icons/feature-icon-14.svg": 12831,
	"./icons/find-icon.svg": 85412,
	"./icons/flag-01.svg": 44623,
	"./icons/flag-02.svg": 42300,
	"./icons/flag-03.svg": 70845,
	"./icons/flag-04.svg": 36914,
	"./icons/global-nine.svg": 60991,
	"./icons/global.svg": 57558,
	"./icons/google-icon.svg": 68648,
	"./icons/googleplay-six.svg": 16691,
	"./icons/goolge-play.svg": 40947,
	"./icons/group-stars.svg": 3792,
	"./icons/gui-calendar-planner-eight.svg": 2094,
	"./icons/gui-calendar-planner.svg": 86960,
	"./icons/icon-upload.svg": 56946,
	"./icons/instagram.svg": 44493,
	"./icons/install-icon-01.svg": 41286,
	"./icons/install-icon-02.svg": 77509,
	"./icons/install-icon-03.svg": 99492,
	"./icons/install-icon-04.svg": 47851,
	"./icons/install-icon-05.svg": 42586,
	"./icons/like-svg.svg": 91939,
	"./icons/linkedin.svg": 41185,
	"./icons/loc-bg.svg": 48061,
	"./icons/loc-icon.svg": 79871,
	"./icons/location.svg": 4198,
	"./icons/mastercard.svg": 88939,
	"./icons/mini-pink-feet.svg": 79651,
	"./icons/money-cash-svgrepo-com.svg": 6626,
	"./icons/move-in.svg": 54924,
	"./icons/offer-icon-01.png": 6893,
	"./icons/offer-icon.svg": 81119,
	"./icons/office-cleaning.svg": 83589,
	"./icons/painting.svg": 71419,
	"./icons/pay-per-eight.svg": 79547,
	"./icons/pay-solution.svg": 12669,
	"./icons/payment-01.svg": 11817,
	"./icons/payment-02.svg": 96730,
	"./icons/payment-03.svg": 38168,
	"./icons/payment-04.svg": 53636,
	"./icons/payment1.svg": 89596,
	"./icons/payment2.svg": 68623,
	"./icons/paypal.svg": 59942,
	"./icons/pink-dog-feet.svg": 54355,
	"./icons/place-icon.svg": 35058,
	"./icons/pointer-eight.svg": 66420,
	"./icons/pricing-seven-1.svg": 81469,
	"./icons/pricing-seven-2.svg": 27294,
	"./icons/pricing-seven-3.svg": 89871,
	"./icons/project-completed.svg": 32318,
	"./icons/quality-svgrepo-com.svg": 85795,
	"./icons/quote.png": 20129,
	"./icons/quote.svg": 62937,
	"./icons/razor-pay.svg": 36084,
	"./icons/reviews-quote.svg": 78485,
	"./icons/sallon-bg.jpg": 82716,
	"./icons/sallon-bg.png": 30200,
	"./icons/saloon-bg.svg": 79673,
	"./icons/scan-six.svg": 63891,
	"./icons/server-icon.svg": 1740,
	"./icons/service-01.svg": 86492,
	"./icons/service-02.svg": 65519,
	"./icons/service-03.svg": 86590,
	"./icons/service-04.svg": 46497,
	"./icons/service-05.svg": 48048,
	"./icons/service-icon-01.svg": 17330,
	"./icons/service-icon-02.svg": 22369,
	"./icons/service-icon-03.svg": 10128,
	"./icons/service-icon-04.svg": 76015,
	"./icons/service-icon-05.svg": 97086,
	"./icons/shave.svg": 44512,
	"./icons/sms.svg": 10114,
	"./icons/sofa.svg": 82014,
	"./icons/square.svg": 4990,
	"./icons/star-01.svg": 99177,
	"./icons/star-icon.svg": 5635,
	"./icons/stripe.svg": 16520,
	"./icons/style-logo.svg": 50894,
	"./icons/success-01.svg": 81280,
	"./icons/success-02.svg": 52179,
	"./icons/success-03.svg": 89538,
	"./icons/suitcase.svg": 86064,
	"./icons/support.svg": 17444,
	"./icons/test-quote.svg": 44776,
	"./icons/tick-banner.svg": 94323,
	"./icons/top-wave.png": 31496,
	"./icons/trash-alt.svg": 28165,
	"./icons/trim.svg": 96783,
	"./icons/trophy-svgrepo-com.svg": 93256,
	"./icons/twitter.svg": 97776,
	"./icons/upload-icon.svg": 5818,
	"./icons/vacuum-cleaner.svg": 60895,
	"./icons/visa.svg": 29436,
	"./icons/wallet-icon.svg": 29314,
	"./icons/whatsapp.svg": 85345,
	"./icons/win.svg": 16695,
	"./icons/window-cleaner-detergent-svgrepo-com.svg": 63772,
	"./icons/window-cleaner.svg": 64042,
	"./icons/window-cleaning.svg": 27905,
	"./icons/work-01.svg": 75736,
	"./icons/work-02.svg": 33803,
	"./icons/work-03.svg": 56282,
	"./icons/work-icon-01.svg": 17278,
	"./icons/work-icon-02.svg": 63549,
	"./icons/work-icon-03.svg": 35004,
	"./icons/work-icon-hand.svg": 59784,
	"./icons/work-icon.svg": 77294,
	"./icons/work-seven-1.svg": 22690,
	"./icons/work-seven-2.svg": 59409,
	"./icons/work-seven-3.svg": 23456,
	"./icons/working-1.svg": 32002,
	"./icons/working-2.svg": 52369,
	"./icons/working-3.svg": 16416,
	"./icons/working-4.svg": 82303,
	"./icons/youtube.svg": 60774,
	"./iplay.png": 433,
	"./logo-2.svg": 23018,
	"./logo-icon.png": 54059,
	"./logo-small.svg": 42797,
	"./logo-white.svg": 64415,
	"./logo.svg": 67503,
	"./mechanic/mechanic-01.jpg": 48253,
	"./mechanic/mechanic-02.jpg": 38354,
	"./mechanic/mechanic-03.jpg": 22639,
	"./mechanic/mechanic-04.jpg": 28324,
	"./mechanic/mechanic-05.jpg": 6369,
	"./mobile.png": 54438,
	"./mobile.svg": 5444,
	"./new-app-bg.png": 4480,
	"./new-app-img.png": 68532,
	"./new-app-sec-ng.png": 76588,
	"./new-app-six-bg.png": 72229,
	"./offer-img.png": 96030,
	"./offer.png": 67164,
	"./offering-worker.png": 73767,
	"./oru-company-bg.png": 2158,
	"./partner/partner-01.svg": 79873,
	"./partner/partner-02.svg": 86738,
	"./partner/partner-03.svg": 1379,
	"./partner/partner-04.svg": 31196,
	"./partner/partner-05.svg": 20669,
	"./partner/partner-10.svg": 54291,
	"./partner/partner-11.svg": 49122,
	"./partner/partner-12.svg": 69489,
	"./partner/partner-7.svg": 31135,
	"./partner/partner-8.svg": 5867,
	"./partner/partner-9.svg": 3753,
	"./partner/partner1.svg": 39972,
	"./partner/partner2.svg": 44567,
	"./partner/partner3.svg": 81766,
	"./partner/partner4.svg": 8649,
	"./partner/partner5.svg": 49496,
	"./partner/partner6.svg": 88331,
	"./payment-success.svg": 92878,
	"./payment/card-01.png": 99207,
	"./payment/card-02.png": 80204,
	"./payment/card-03.png": 32469,
	"./payment/card-04.png": 92346,
	"./payment/card-05.png": 56451,
	"./payment/card-06.png": 19592,
	"./payment/discover.png": 31724,
	"./payment/mastercard.png": 2129,
	"./payment/stripe.png": 13229,
	"./payment/visa.png": 44614,
	"./pets/pet-01.jpg": 11458,
	"./pets/pet-02.jpg": 57389,
	"./pets/pet-03.jpg": 5168,
	"./pets/pet-04.jpg": 81443,
	"./pets/pet-05.jpg": 38310,
	"./pets/pet-06.jpg": 66065,
	"./professional-eight.png": 43827,
	"./profiles/avatar-01.jpg": 54802,
	"./profiles/avatar-02.jpg": 92605,
	"./profiles/avatar-03.jpg": 24512,
	"./profiles/avatar-04.jpg": 14675,
	"./profiles/avatar-05.jpg": 86262,
	"./profiles/avatar-06.jpg": 62049,
	"./profiles/avatar-07.jpg": 88452,
	"./profiles/avatar-08.jpg": 83607,
	"./profiles/avatar-09.jpg": 31674,
	"./profiles/avatar-10.jpg": 16880,
	"./profiles/avatar-11.jpg": 17805,
	"./profiles/avatar-12.jpg": 88546,
	"./profiles/avatar-13.jpg": 1215,
	"./profiles/avatar-14.jpg": 80404,
	"./profiles/avatar-15.jpg": 77777,
	"./profiles/avatar-16.jpg": 36358,
	"./profiles/avatar-17.jpg": 58531,
	"./profiles/avatar-18.jpg": 95032,
	"./profiles/avatar-19.jpg": 56213,
	"./profiles/avatar-20.jpg": 8385,
	"./profiles/avatar-21.jpg": 30340,
	"./profiles/avatar-22.jpg": 81971,
	"./profiles/avatar-23.jpg": 18806,
	"./profiles/avatar-24.jpg": 50269,
	"./profiles/avatar-25.jpg": 11040,
	"./profiles/avatar-26.jpg": 24655,
	"./profiles/avatar-27.jpg": 40370,
	"./profiles/avatar-28.jpg": 19081,
	"./profiles/avatar-29.jpg": 73708,
	"./profiles/avatar-30.jpg": 73962,
	"./profiles/avatar-31.jpg": 29799,
	"./profiles/avatar-32.jpg": 75992,
	"./profiles/avatar-33.jpg": 83861,
	"./profiles/avatar-34.jpg": 37742,
	"./profiles/avatar-35.jpg": 15787,
	"./profiles/avatar-36.jpg": 23804,
	"./profiles/avatar-37.jpg": 44857,
	"./profiles/avatar-38.jpg": 90466,
	"./profiles/avatar-39.jpg": 82175,
	"./profiles/avatar-40.jpg": 17531,
	"./profiles/avatar-41.jpg": 16222,
	"./profiles/avatar-42.jpg": 12169,
	"./profiles/avatar-43.jpg": 40556,
	"./profiles/avatar-44.jpg": 46871,
	"./profiles/avatar-45.jpg": 75706,
	"./profiles/avatar-46.jpg": 63557,
	"./profiles/avatar-47.jpg": 35944,
	"./profiles/avatar-48.jpg": 58707,
	"./profiles/avatar-49.jpg": 3446,
	"./profiles/avatar-50.jpg": 24828,
	"./profiles/avatar-51.jpg": 38553,
	"./profiles/avatar-52.jpg": 66062,
	"./profiles/avatar-53.jpg": 92523,
	"./profiles/avatar-54.jpg": 86040,
	"./profiles/avatar-55.jpg": 76949,
	"./provider/provider-01.jpg": 1367,
	"./provider/provider-02.jpg": 90440,
	"./provider/provider-03.jpg": 34405,
	"./provider/provider-04.jpg": 70718,
	"./provider/provider-05.jpg": 72027,
	"./provider/provider-06.jpg": 95052,
	"./provider/provider-07.jpg": 66665,
	"./provider/provider-08.jpg": 95858,
	"./provider/provider-09.jpg": 55887,
	"./provider/provider-10.jpg": 99569,
	"./provider/provider-11.jpg": 85236,
	"./provider/provider-12.jpg": 31299,
	"./provider/provider-13.jpg": 71814,
	"./provider/provider-14.jpg": 7245,
	"./provider/provider-15.jpg": 38672,
	"./provider/provider-16.jpg": 53023,
	"./provider/provider-17.jpg": 44962,
	"./provider/provider-18.jpg": 99353,
	"./provider/provider-19.jpg": 78300,
	"./provider/provider-20.jpg": 65536,
	"./provider/provider-21.jpg": 4765,
	"./provider/provider-22.jpg": 11218,
	"./provider/provider.png": 61979,
	"./providers/provider-01.jpg": 60168,
	"./providers/provider-02.jpg": 71095,
	"./providers/provider-03.jpg": 99930,
	"./providers/provider-04.jpg": 20041,
	"./providers/provider-05.jpg": 64780,
	"./providers/provider-06.jpg": 41755,
	"./providers/provider-07.jpg": 40446,
	"./providers/provider-08.jpg": 68189,
	"./providers/provider-09.jpg": 42624,
	"./providers/provider-10.jpg": 90286,
	"./providers/provider-11.jpg": 16747,
	"./providers/provider-12.jpg": 49052,
	"./providers/provider-13.jpg": 46425,
	"./providers/provider-14.jpg": 33834,
	"./providers/provider-15.jpg": 72839,
	"./providers/provider-16.jpg": 93912,
	"./providers/provider-17.jpg": 1173,
	"./providers/provider-18.jpg": 11942,
	"./providers/provider-19.jpg": 76643,
	"./providers/provider-20.jpg": 6195,
	"./providers/provider-21.jpg": 43030,
	"./providers/provider-22.jpg": 32609,
	"./providers/provider-23.jpg": 54564,
	"./providers/provider-24.jpg": 32527,
	"./providers/provider-25.jpg": 64594,
	"./providers/provider-26.jpg": 74493,
	"./providers/provider-30.jpg": 54964,
	"./providers/provider-31.jpg": 69297,
	"./providers/provider-32.jpg": 41542,
	"./providers/provider-33.jpg": 84675,
	"./providers/provider-34.jpg": 8400,
	"./providers/provider-35.jpg": 60621,
	"./providers/provider-36.jpg": 14690,
	"./providers/provider-37.jpg": 6399,
	"./providers/provider-38.jpg": 48028,
	"./providers/provider-39.jpg": 52729,
	"./providers/provider-40.jpg": 79577,
	"./providers/provider-41.jpg": 9052,
	"./saloon-banner.jpg": 81693,
	"./saloon-bg.jpg": 75722,
	"./scan-img.png": 82449,
	"./service-img-10.jpg": 91855,
	"./service-img-9.jpg": 76135,
	"./service-request.jpg": 73991,
	"./services/add-service-01.jpg": 17088,
	"./services/add-service-02.jpg": 14351,
	"./services/add-service-03.jpg": 58322,
	"./services/add-service-04.jpg": 83809,
	"./services/add-service-05.jpg": 5764,
	"./services/addservice-01.jpg": 23915,
	"./services/addservice-02.jpg": 55612,
	"./services/addservice-03.jpg": 26137,
	"./services/addservice-04.jpg": 5770,
	"./services/addservice-05.jpg": 57159,
	"./services/banner1.png": 45182,
	"./services/banner2.png": 12533,
	"./services/banner3.png": 27084,
	"./services/banner4.png": 57251,
	"./services/cuttor-sm-white.svg": 91307,
	"./services/mechanic-feature-01.jpg": 7164,
	"./services/mechanic-feature-02.jpg": 99147,
	"./services/mechanic-feature-03.jpg": 21102,
	"./services/mechanic-service-01.jpg": 48033,
	"./services/mechanic-service-02.jpg": 58454,
	"./services/mechanic-service-03.jpg": 5267,
	"./services/mechanic-service-04.jpg": 34336,
	"./services/rated-service-01.jpg": 60461,
	"./services/rated-service-02.jpg": 31202,
	"./services/rated-service-03.jpg": 43871,
	"./services/rated-service-04.jpg": 23060,
	"./services/rated-service-05.jpg": 20433,
	"./services/rated-service-06.jpg": 62662,
	"./services/rated-service-07.jpg": 1187,
	"./services/rated-service-08.jpg": 37688,
	"./services/rated-service-09.jpg": 98869,
	"./services/rated-service-10.jpg": 57487,
	"./services/rated-service-11.jpg": 81106,
	"./services/rated-service-12.jpg": 35261,
	"./services/rated-service-13.jpg": 67168,
	"./services/rated-service-14.jpg": 57331,
	"./services/rated-service-15.jpg": 12566,
	"./services/rated-service-16.jpg": 4705,
	"./services/rated-service-17.jpg": 14756,
	"./services/rated-service-18.jpg": 26263,
	"./services/rated-service-19.jpg": 57978,
	"./services/rated-service-20.jpg": 266,
	"./services/rated-service-21.jpg": 56103,
	"./services/rated-service-22.jpg": 18648,
	"./services/rated-service-23.jpg": 26517,
	"./services/rated-service-24.jpg": 64046,
	"./services/repair-img.png": 55984,
	"./services/service-01.jpg": 32742,
	"./services/service-02.jpg": 90513,
	"./services/service-03.jpg": 76788,
	"./services/service-04.jpg": 13951,
	"./services/service-05.jpg": 1282,
	"./services/service-06.jpg": 14189,
	"./services/service-07.jpg": 29616,
	"./services/service-08.jpg": 95019,
	"./services/service-09.jpg": 15534,
	"./services/service-10.jpg": 26724,
	"./services/service-100.jpg": 11174,
	"./services/service-101.jpg": 54307,
	"./services/service-102.jpg": 24596,
	"./services/service-103.jpg": 38929,
	"./services/service-104.jpg": 84322,
	"./services/service-105.jpg": 76031,
	"./services/service-106.jpg": 78032,
	"./services/service-107.jpg": 30253,
	"./services/service-108.jpg": 31598,
	"./services/service-109.jpg": 9643,
	"./services/service-11.jpg": 4769,
	"./services/service-12.jpg": 15190,
	"./services/service-13.jpg": 78355,
	"./services/service-14.jpg": 7424,
	"./services/service-15.jpg": 46653,
	"./services/service-16.jpg": 53106,
	"./services/service-17.jpg": 21039,
	"./services/service-18.jpg": 70092,
	"./services/service-19.jpg": 15465,
	"./services/service-20.jpg": 96597,
	"./services/service-21.jpg": 88728,
	"./services/service-22.jpg": 26183,
	"./services/service-23.jpg": 70346,
	"./services/service-24.jpg": 41241,
	"./services/service-25.jpg": 20188,
	"./services/service-26.jpg": 12171,
	"./services/service-27.jpg": 34126,
	"./services/service-28.jpg": 49133,
	"./services/service-29.jpg": 80560,
	"./services/service-30.jpg": 12606,
	"./services/service-31.jpg": 13915,
	"./services/service-32.jpg": 36940,
	"./services/service-33.jpg": 8553,
	"./services/service-34.jpg": 72090,
	"./services/service-35.jpg": 43255,
	"./services/service-37.jpg": 59941,
	"./services/service-38.jpg": 99830,
	"./services/service-39.jpg": 71443,
	"./services/service-40.jpg": 52919,
	"./services/service-41.jpg": 81754,
	"./services/service-42.jpg": 69605,
	"./services/service-43.jpg": 41992,
	"./services/service-44.jpg": 23579,
	"./services/service-45.jpg": 22270,
	"./services/service-46.jpg": 18217,
	"./services/service-47.jpg": 46604,
	"./services/service-48.jpg": 7439,
	"./services/service-49.jpg": 31058,
	"./services/service-50.jpg": 92088,
	"./services/service-51.jpg": 82997,
	"./services/service-52.jpg": 32010,
	"./services/service-53.jpg": 54663,
	"./services/service-54.jpg": 30876,
	"./services/service-55.jpg": 44601,
	"./services/service-56.jpg": 72110,
	"./services/service-57.jpg": 14923,
	"./services/service-58.jpg": 43664,
	"./services/service-59.jpg": 87117,
	"./services/service-60.jpg": 11689,
	"./services/service-61.jpg": 73644,
	"./services/service-62.jpg": 16443,
	"./services/service-63.jpg": 68606,
	"./services/service-64.jpg": 13605,
	"./services/service-65.jpg": 86440,
	"./services/service-66.jpg": 54839,
	"./services/service-67.jpg": 91002,
	"./services/service-68.jpg": 58465,
	"./services/service-69.jpg": 80420,
	"./services/service-70.jpg": 51186,
	"./services/service-71.jpg": 27567,
	"./services/service-72.jpg": 37248,
	"./services/service-73.jpg": 88989,
	"./services/service-74.jpg": 82646,
	"./services/service-75.jpg": 27411,
	"./services/service-76.jpg": 84836,
	"./services/service-77.jpg": 74785,
	"./services/service-78.jpg": 28058,
	"./services/service-79.jpg": 79991,
	"./services/service-80.jpg": 75531,
	"./services/service-81.jpg": 97486,
	"./services/service-82.jpg": 77753,
	"./services/service-82.png": 59489,
	"./services/service-83.jpg": 90876,
	"./services/service-83.png": 38360,
	"./services/service-84.jpg": 8775,
	"./services/service-84.png": 87351,
	"./services/service-85.jpg": 41034,
	"./services/service-86.jpg": 33109,
	"./services/service-87.jpg": 28792,
	"./services/service-88.jpg": 86403,
	"./services/service-89.jpg": 96294,
	"./services/service-90.jpg": 77004,
	"./services/service-91.jpg": 91145,
	"./services/service-92.jpg": 99646,
	"./services/service-93.jpg": 19803,
	"./services/service-94.jpg": 14920,
	"./services/service-95.jpg": 42533,
	"./services/service-96.jpg": 85306,
	"./services/service-97.jpg": 37239,
	"./services/service-98.jpg": 42084,
	"./services/service-99.jpg": 32033,
	"./services/service-b-01.jpg": 80969,
	"./services/service-b-02.jpg": 89470,
	"./services/service-b-03.jpg": 9627,
	"./services/service-b-04.jpg": 4744,
	"./services/service-b-05.jpg": 48709,
	"./services/service-b-06.jpg": 91482,
	"./services/service-ban-02.jpg": 95181,
	"./services/service-slider-01.jpg": 83558,
	"./services/service-slider-02.jpg": 24977,
	"./services/service-slider-03.jpg": 27604,
	"./services/service-slider-04.jpg": 48415,
	"./services/service-slider-05.jpg": 35746,
	"./services/service-slider-06.jpg": 65005,
	"./services/service-thumb-01.jpg": 82119,
	"./services/service-thumb-02.jpg": 3192,
	"./services/service-thumb-03.jpg": 10453,
	"./services/service-thumb-04.jpg": 99566,
	"./services/service-thumb-05.jpg": 26027,
	"./services/service-thumb-06.jpg": 58332,
	"./side-circle.png": 47460,
	"./team/team-01.jpg": 25439,
	"./team/team-02.jpg": 94128,
	"./team/team-03.jpg": 37581,
	"./team/team-04.jpg": 44230,
	"./team/team-05.jpg": 25283,
	"./team/team-06.jpg": 23476,
	"./team/team-07.jpg": 2001,
	"./team/team-08.jpg": 82474,
	"./testimonial-map.svg": 26214,
	"./testimonials-seven.png": 22616,
	"./user/user-01.jpg": 25155,
	"./user/user-02.jpg": 79092,
	"./user/user-03.jpg": 50897,
	"./user/user-04.jpg": 65666,
	"./user/user-05.jpg": 73727,
	"./user/user-06.jpg": 90000,
	"./user/user-07.jpg": 34893,
	"./user/user-08.jpg": 36238,
	"./user/user-09.jpg": 14283,
	"./user/user-10.jpg": 91293,
	"./user/user-11.jpg": 40160,
	"./user/user-12.jpg": 53775,
	"./user/user-13.jpg": 81394,
	"./user/user-14.jpg": 6881,
	"./user/user-15.jpg": 28836,
	"./user/user-16.jpg": 22995,
	"./user/user-17.jpg": 36534,
	"./user/user-18.jpg": 62021,
	"./user/user-19.jpg": 34856,
	"./user/user-20.jpg": 42604,
	"./video.jpg": 67935,
	"./white-logo.svg": 14819,
	"./works-1.jpg": 22882,
	"./works-2.jpg": 68813,
	"./works-3.jpg": 16592,
	"./works-six-1.png": 74289,
	"./works-six-2.png": 53178,
	"./works-six-3.png": 931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;